import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import fetchRequest from 'services/api';

function DownLoadDocumentContainer() {
  const [initialized, setInitialized] = useState(null);

  const { fileId, tenantId } = useParams();

  const title = decodeURI(fileId);

  function onOpenFile(file) {
    const downloadLink = document.createElement('a');
    fetchRequest({
      url: `File/Contents?id=${file.id}`,
      ignoreContentType: true
    })
      .then((response) => {
        const contentDisposition = response.headers.get('content-disposition');
        let fileName = file.name;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename=["']?(.+?)["']?;/);

          if (match && match[1]) {
            // eslint-disable-next-line prefer-destructuring
            fileName = match[1];
          }
        }

        return response.blob().then((blob) => ({ blob, fileName }));
      })
      .then(({ blob, fileName }) => {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          return navigator.msSaveOrOpenBlob(blob, fileName);
        }
        return { blobUrl: URL.createObjectURL(blob), fileName };
      })
      .then(({ blobUrl, fileName }) => {
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        if (typeof window.navigator.msSaveBlob === 'undefined') {
          downloadLink.click();
        }
        URL.revokeObjectURL(blobUrl);
      });
  }

  useEffect(() => {
    if (!initialized && tenantId) {
      window.localStorage.setItem('tenantId', tenantId);
      setInitialized(true);
    }
  }, [tenantId, initialized]);

  useEffect(() => {
    onOpenFile({ name: title, id: fileId });
  }, [fileId, title]);

  return null;
}

export default DownLoadDocumentContainer;
